<template>
<div class="chapter">
<div class="inner_page">
<div id="fm2">
<p class="title"><img alt="" class="Figure" src="images/image_0001.jpg"/></p>
<p class="title1"><span>MO HAYDER</span></p>
<p class="title1a">
<img alt="" class="Figure" src="images/image_0002.jpg"/></p>
<p class="title3"><span>GROVE PRESS</span></p>
<p class="title3"><span>NEW YORK</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?70a21424